import React from 'react';
import { useSelector } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import QRImage from 'react-qr-image';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';
import jsPDF from 'jspdf';
import _ from 'underscore';

import logoBlack from 'ui/assets/envio-black.png';
import { formatDate, currencyFormat } from 'utilities/common';

const POD_URL = `${process.env.REACT_APP_POD_SYSTEM_URL}`;
let doc = new jsPDF('portrait', 'pt', 'a4');

const PDFManifest = ({ data, logo }) => {
  const Client = useSelector((state) => state?.Auth?.session?.client);

  const [page, setPage] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [firstPage] = React.useState(5);
  const [limit] = React.useState(7);
  const [shipmentItem, setShipmentItem] = React.useState(null);

  const save = () => {
    setLoading(true);

    doc.html(ReactDOMServer.renderToStaticMarkup(manifest), {
      callback: () => {
        // last page hapus aja ya okeh :)
        doc.deletePage(doc.internal.getNumberOfPages());
        doc.save(`${data?.code}.pdf`);
        doc = new jsPDF('p', 'pt', 'a4');
        setLoading(false);
      },
    });
  };

  React.useEffect(() => {
    if (data) {
      let pages = [];

      if (data?.legs) {
        pages = _.chunk(data?.legs, firstPage);
        if (data?.legs?.length > firstPage) {
          let first = pages[0];
          let last = _.rest(data?.legs, first?.length);
          pages = _.chunk(last, limit);
          pages.unshift(first);
        } else {
          setPage(pages);
        }
      } else {
        pages = _.chunk(data?.jobs, firstPage);
        if (data?.jobs?.length > firstPage) {
          let first = pages[0];
          let last = _.rest(data?.jobs, first?.length);
          pages = _.chunk(last, limit);
          pages.unshift(first);
        } else {
          setPage(pages);
        }
      }

      let tkol = 0;
      let tweight = 0;
      _.each(data?.jobs, function (i) {
        tkol += i?.delivery_order?.shipment?.total_quantity;
        tweight += i?.delivery_order?.shipment?.total_weight;
      });

      setShipmentItem({ total_quantity: tkol, total_weight: tweight });
      setPage(pages);
    }
  }, [data]);

  if (!data) return null;

  const TableLastMile = ({ pageData, id }) => {
    if (!(data?.type === 'last_mile' || data?.type === 'return')) return null;

    return (
      <>
        <div className="row bg-primary mt-3">
          <div className="col-1 text-start py-2 pe-0">
            <p className="fw-bold pdf-text text-white">No</p>
          </div>
          <div className="col-2 text-start py-2 ps-0">
            <p className="fw-bold pdf-text text-white">Pickup/Drop</p>
          </div>
          <div className="col-2 text-start py-2">
            <p className="fw-bold pdf-text text-white">Lokasi</p>
          </div>
          <div className="col-2 text-center py-2">
            <p className="fw-bold pdf-text text-white">Shipment</p>
          </div>
          <div className="col-3 text-center py-2">
            <p className="fw-bold pdf-text text-white">Shipment Detail</p>
          </div>
          <div className="col-2 text-center py-2">
            <p className="fw-bold pdf-text text-white">Catatan</p>
          </div>
        </div>
        {pageData?.map((d, i) => {
          let newData = [];
          let comodity = [];
          _.map(d?.jobs, function (job) {
            _.each(job?.delivery_order?.shipment?.items, function (item) {
              comodity.push(item);
            });
          });

          if (comodity?.length > 0) {
            let x = _.uniq(comodity, 'item_name');
            _.each(x, function (u) {
              let uniqs = _.where(comodity, {
                item_name: u?.item_name,
              });

              let weight = _.reduce(
                uniqs,
                function (memo, num) {
                  return memo + (num?.m3 > num?.weight ? num?.m3 : num?.weight);
                },
                0
              );

              let qty = _.reduce(
                uniqs,
                function (memo, num) {
                  return memo + num?.quantity;
                },
                0
              );

              let newObj = {
                item_name: u?.item_name,
                total_weight: weight,
                total_quantity: qty,
              };

              newData?.push(newObj);
            });
          }

          return (
            <div className="row bg-white border-bottom">
              <div className="col-1 text-start py-2 pe-0">
                <p className="pdf-text text-secondary">
                  {id > 1
                    ? limit + (firstPage * (id - 1) + i + 1)
                    : firstPage * id + i + 1}
                </p>
              </div>
              <div className="col-2 text-start py-2 ps-0">
                <p className="pdf-text text-capitalize">
                  {d?.type?.replace('_', ' ')}
                </p>
              </div>
              <div className="col-2 text-start py-2">
                <p className="pdf-head text-secondary text-capitalize">
                  {d?.location?.name} - {d?.location?.phone_number}
                </p>
                <p
                  className="pdf-subtitle text-secondary text-capitalize"
                  style={{ fontSize: 7 }}
                >
                  {d?.location?.address}
                </p>
                <p
                  className="pdf-subtitle text-secondary text-capitalize"
                  style={{ fontSize: 7 }}
                >
                  {d?.location?.region?.district_name},{' '}
                  {d?.location?.region?.regency_name},{' '}
                  {d?.location?.region?.province_name}
                </p>
              </div>
              <div className="col-2 text-start py-2">
                {d?.jobs?.map((jo, i) => (
                  <p
                    key={i}
                    className="pdf-subtitle text-secondary text-capitalize"
                  >
                    {i + 1}. {jo?.delivery_order?.shipment?.code || '-'}
                    {jo?.delivery_order?.shipment?.ref_code}
                  </p>
                ))}
              </div>
              <div className="col-3 text-start py-2">
                <p className="pdf-head text-secondary text-capitalize">
                  Komoditas :
                </p>
                {newData?.map((item, i) => (
                  <p
                    className="pdf-subtitle text-secondary text-capitalize"
                    key={i}
                  >
                    {i + 1}. {item?.item_name || '-'} :{' '}
                    {currencyFormat(item?.total_weight || 0)} Kg (
                    {currencyFormat(item?.total_quantity || 0)} Koli)
                  </p>
                ))}
                <p className="pdf-subtitle text-secondary text-capitalize">
                  <span style={{ fontWeight: 700 }}>Total Berat : </span>
                  {`
                    ${currencyFormat(
                      _.reduce(
                        d?.jobs,
                        function (job, i) {
                          let x = _.reduce(
                            i?.delivery_order?.shipment?.items,
                            function (s, o) {
                              return s + o?.weight;
                            },
                            0
                          );
                          return job + x;
                        },
                        0
                      )
                    )} KG
                    (${currencyFormat(
                      _.reduce(
                        d?.jobs,
                        function (job, i) {
                          let x = _.reduce(
                            i?.delivery_order?.shipment?.items,
                            function (s, o) {
                              return s + o?.quantity;
                            },
                            0
                          );
                          return job + x;
                        },
                        0
                      )
                    )} Koli)
                  `}
                </p>
                {d?.type === 'drop_point' &&
                  data?.moda_type === 'land_freight' && (
                    <p className="pdf-subtitle text-secondary text-capitalize">
                      <span style={{ fontWeight: 700 }}>COD : </span>
                      {currencyFormat(
                        _.reduce(
                          d?.jobs,
                          function (job, i) {
                            return job + i?.delivery_order?.shipment?.cod_value;
                          },
                          0
                        )
                      )}
                    </p>
                  )}
              </div>
              <div className="col-2 text-start py-2">
                <p className="pdf-subtitle text-secondary text-capitalize">
                  {(d?.jobs?.length > 0 &&
                    d?.jobs[0]?.delivery_order?.shipment?.instruction) ||
                    '-'}
                </p>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const TableFirstConsole = ({ pageData, id }) => {
    if (!(data?.type === 'console' || data?.type === 'pickup')) return null;

    return (
      <>
        <div className="row bg-primary mt-3">
          <div className="col-1 text-start py-2 pe-0">
            <p className="fw-bold pdf-text text-white">No</p>
          </div>
          <div className="col-2 text-start py-2 ps-0">
            <p className="fw-bold pdf-text text-white">Pickup/Drop</p>
          </div>
          <div className="col-2 text-start py-2">
            <p className="fw-bold pdf-text text-white">Lokasi</p>
          </div>
          <div className="col-2 text-center py-2">
            <p className="fw-bold pdf-text text-white">Shipment</p>
          </div>
          <div className="col-3 text-center py-2">
            <p className="fw-bold pdf-text text-white">Shipment Detail</p>
          </div>
          <div className="col-2 text-center py-2">
            <p className="fw-bold pdf-text text-white">Catatan</p>
          </div>
        </div>
        {pageData?.map((d, i) => {
          let newData = [];
          let comodity = [];
          _.map(d?.jobs, function (job) {
            _.each(job?.delivery_order?.shipment?.items, function (item) {
              comodity.push(item);
            });
          });

          if (comodity?.length > 0) {
            let x = _.uniq(comodity, 'item_name');
            _.each(x, function (u) {
              let uniqs = _.where(comodity, {
                item_name: u?.item_name,
              });

              let weight = _.reduce(
                uniqs,
                function (memo, num) {
                  return memo + (num?.m3 > num?.weight ? num?.m3 : num?.weight);
                },
                0
              );

              let qty = _.reduce(
                uniqs,
                function (memo, num) {
                  return memo + num?.quantity;
                },
                0
              );

              let newObj = {
                item_name: u?.item_name,
                total_weight: weight,
                total_quantity: qty,
              };

              newData?.push(newObj);
            });
          }

          return (
            <div className="row bg-white border-bottom">
              <div className="col-1 text-start py-2 pe-0">
                <p className="pdf-text text-secondary">
                  {id > 1
                    ? limit + (firstPage * (id - 1) + i + 1)
                    : firstPage * id + i + 1}
                </p>
              </div>
              <div className="col-2 text-start py-2 ps-0">
                <p className="pdf-text text-capitalize">
                  {d?.type?.replace('_', ' ')}
                </p>
              </div>
              <div className="col-2 text-start py-2">
                <p className="pdf-head text-secondary text-capitalize">
                  {d?.location?.name} - {d?.location?.phone_number}
                </p>
                <p
                  className="pdf-subtitle text-secondary text-capitalize"
                  style={{ fontSize: 7 }}
                >
                  {d?.location?.address}
                </p>
                <p
                  className="pdf-subtitle text-secondary text-capitalize"
                  style={{ fontSize: 7 }}
                >
                  {d?.location?.region?.district_name},{' '}
                  {d?.location?.region?.regency_name},{' '}
                  {d?.location?.region?.province_name}
                </p>
              </div>
              <div className="col-2 text-start py-2">
                {d?.jobs?.map((jo, i) => (
                  <p
                    key={i}
                    className="pdf-subtitle text-secondary text-capitalize"
                  >
                    {i + 1}. {jo?.delivery_order?.shipment?.code || '-'}
                    {jo?.delivery_order?.shipment?.ref_code}
                  </p>
                ))}
              </div>
              <div className="col-3 text-start py-2">
                <p className="pdf-head text-secondary text-capitalize">
                  Komoditas :
                </p>
                {newData?.map((item, i) => (
                  <p
                    className="pdf-subtitle text-secondary text-capitalize"
                    key={i}
                  >
                    {i + 1}. {item?.item_name || '-'} :{' '}
                    {currencyFormat(item?.total_weight || 0)} Kg (
                    {currencyFormat(item?.total_quantity || 0)} Koli)
                  </p>
                ))}
                <p className="pdf-subtitle text-secondary text-capitalize">
                  <span style={{ fontWeight: 700 }}>Total Berat : </span>
                  {`
                    ${currencyFormat(
                      _.reduce(
                        d?.jobs,
                        function (job, i) {
                          let x = _.reduce(
                            i?.delivery_order?.shipment?.items,
                            function (s, o) {
                              return s + o?.weight;
                            },
                            0
                          );
                          return job + x;
                        },
                        0
                      )
                    )} KG
                    (${currencyFormat(
                      _.reduce(
                        d?.jobs,
                        function (job, i) {
                          let x = _.reduce(
                            i?.delivery_order?.shipment?.items,
                            function (s, o) {
                              return s + o?.quantity;
                            },
                            0
                          );
                          return job + x;
                        },
                        0
                      )
                    )} Koli)
                  `}
                </p>
              </div>
              <div className="col-2 text-start py-2">
                <p className="pdf-subtitle text-secondary text-capitalize">
                  {(d?.jobs?.length > 0 &&
                    d?.jobs[0]?.delivery_order?.shipment?.instruction) ||
                    '-'}
                </p>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const TableForwarder = ({ pageData, id }) => {
    if (!(data?.type === 'forwarder')) return null;

    return (
      <>
        <div className="row bg-primary mt-3">
          <div className="col-1 text-start py-2 pe-0">
            <p className="fw-bold pdf-text text-white">No</p>
          </div>
          <div className="col-2 text-start py-2 ps-0">
            <p className="fw-bold pdf-text text-white">Shipment</p>
          </div>
          <div className="col-2 text-start py-2 ps-0">
            <p className="fw-bold pdf-text text-white">Pickup/Drop</p>
          </div>
          <div className="col-4 text-start py-2">
            <p className="fw-bold pdf-text text-white">Lokasi</p>
          </div>
          <div className="col-3 text-center py-2">
            <p className="fw-bold pdf-text text-white">Shipment Detail</p>
          </div>
        </div>
        {pageData?.map((d, i) => {
          let newData = [];
          let comodity = [];
          _.each(d?.delivery_order?.shipment?.items, function (item) {
            comodity.push(item);
          });

          if (comodity?.length > 0) {
            let x = _.uniq(comodity, 'item_name');
            _.each(x, function (u) {
              let uniqs = _.where(comodity, {
                item_name: u?.item_name,
              });

              let weight = _.reduce(
                uniqs,
                function (memo, num) {
                  return memo + (num?.m3 > num?.weight ? num?.m3 : num?.weight);
                },
                0
              );

              let qty = _.reduce(
                uniqs,
                function (memo, num) {
                  return memo + num?.quantity;
                },
                0
              );

              let newObj = {
                item_name: u?.item_name,
                total_weight: weight,
                total_quantity: qty,
              };

              newData?.push(newObj);
            });
          }

          return (
            <div className="row bg-white border-bottom">
              <div className="col-1 text-start py-2 pe-0">
                <p className="pdf-text text-secondary">
                  {id > 1
                    ? limit + (firstPage * (id - 1) + i + 1)
                    : firstPage * id + i + 1}
                </p>
              </div>
              <div className="col-2 text-start py-2 ps-0">
                <p className="pdf-text text-capitalize">
                  {d?.delivery_order?.shipment?.code}
                </p>
              </div>
              <div className="col-2 text-start py-2">
                <p className="pdf-head text-secondary text-capitalize">
                  {d?.origin?.name} - {d?.destination?.name}
                </p>
              </div>
              <div className="col-4 text-start py-2">
                <p className="pdf-head text-secondary text-capitalize">
                  {d?.destination?.address}
                </p>
                <p
                  className="pdf-subtitle text-secondary text-capitalize"
                  style={{ fontSize: 7 }}
                >
                  {d?.destination?.region?.district_name},{' '}
                  {d?.destination?.region?.regency_name},{' '}
                  {d?.destination?.region?.province_name}
                </p>
              </div>
              <div className="col-3 text-start py-2">
                <p className="pdf-head text-secondary text-capitalize">
                  Komoditas :
                </p>
                {newData?.map((item, i) => (
                  <p
                    className="pdf-subtitle text-secondary text-capitalize"
                    key={i}
                  >
                    {i + 1}. {item?.item_name || '-'} :{' '}
                    {currencyFormat(item?.total_weight || 0)} Kg (
                    {currencyFormat(item?.total_quantity || 0)} Koli)
                  </p>
                ))}
                {d?.delivery_order?.shipment?.cod_value > 0 && (
                  <p className="pdf-subtitle text-secondary text-capitalize">
                    <span style={{ fontWeight: 700 }}>COD : </span>
                    {currencyFormat(d?.delivery_order?.shipment?.cod_value)}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const manifest = page?.map((p, id) => (
    <section
      className="pdf-sheet"
      style={{ paddingLeft: '20px', paddingRight: '20px' }}
    >
      {id === 0 ? (
        <>
          <div className="row">
            <div className="col-10">
              <div className="row align-items-center border-bottom py-3">
                <div className="col-4">
                  <img
                    src={Client?.avatar?.replace('_thumb', '') || logoBlack}
                    alt=""
                    style={{ maxHeight: 40, maxWidth: '100%' }}
                  />
                </div>
                <div className="col-6">
                  <h2 className="pdf-title text-uppercase">
                    Manifest {data?.type?.replace('_', ' ')}
                  </h2>
                  <p className="pdf-text">
                    Tanggal Manifest :{' '}
                    {formatDate(data?.schedule_at, 'DD-MM-YYYY')}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-2 p-0">
              <div className="d-flex flex-column justify-content-between align-items-center">
                <QRImage
                  text={`${POD_URL}/manifest/${data?.id}`}
                  color="#000"
                  background="#fff"
                  style={{ height: 100 }}
                />
                <p className="pdf-text text-end">{data?.code}</p>
              </div>
            </div>
          </div>
          {data?.type !== 'forwarder' && (
            <div style={{ marginTop: -35, verticalAlign: 'top' }}>
              <p className="pdf-head text-uppercase">Informasi Armada:</p>
              <div className="row mt-0">
                <div className="col-2 pdf-text">Tipe</div>
                <div className="col-1 fs-8 text-center p-0">:</div>
                <div className="col-7 text-uppercase pdf-head">
                  {data?.moda_type?.replace('_', ' ')}
                </div>
              </div>
              {data?.moda_type === 'land_freight' &&
                data?.moda?.land_freight && (
                  <>
                    <div className="row mt-0">
                      <div className="col-2 pdf-text">Driver</div>
                      <div className="col-1 fs-8 text-center p-0">:</div>
                      <div className="col-7 text-uppercase pdf-head">
                        {data?.moda?.land_freight?.driver?.name}
                      </div>
                    </div>
                    <div className="row mt-0">
                      <div className="col-2 pdf-text">Kendaraan</div>
                      <div className="col-1 fs-8 text-center p-0">:</div>
                      <div className="col-7 text-uppercase pdf-head">
                        {data?.moda?.land_freight?.vehicle ? (
                          `${data?.moda?.land_freight?.vehicle?.code}`
                        ):
                          `${data?.moda?.land_freight?.vehicle_type?.name} ${' '}${'-'}${' '}
                           ${data?.moda?.land_freight?.vehicle_number}`
                        }
                      </div>
                    </div>
                  </>
                )}
              {data?.moda_type === 'sea_freight' && data?.moda?.sea_freight && (
                <>
                  <div className="row mt-0">
                    <div className="col-2 pdf-text">BL Code</div>
                    <div className="col-1 fs-8 text-center p-0">:</div>
                    <div className="col-7 text-uppercase pdf-head">
                      {data?.moda?.sea_freight?.bl_code}
                    </div>
                  </div>
                  <div className="row mt-0">
                    <div className="col-2 pdf-text">No. Container</div>
                    <div className="col-1 fs-8 text-center p-0">:</div>
                    <div className="col-7 text-uppercase pdf-head">
                      {data?.moda?.sea_freight?.no_container}
                    </div>
                  </div>
                  <div className="row mt-0">
                    <div className="col-2 pdf-text">No. Vessel</div>
                    <div className="col-1 fs-8 text-center p-0">:</div>
                    <div className="col-7 text-uppercase pdf-head">
                      {data?.moda?.sea_freight?.no_vessel}
                    </div>
                  </div>
                </>
              )}
              {data?.moda_type === 'air_freight' && data?.moda?.air_freight && (
                <>
                  <div className="row mt-0">
                    <div className="col-2 pdf-text">Airplane</div>
                    <div className="col-1 fs-8 text-center p-0">:</div>
                    <div className="col-7 text-uppercase pdf-head">
                      {data?.moda?.air_freight?.airplane}
                    </div>
                  </div>
                  <div className="row mt-0">
                    <div className="col-2 pdf-text">Code SMU</div>
                    <div className="col-1 fs-8 text-center p-0">:</div>
                    <div className="col-7 text-uppercase pdf-head">
                      {data?.moda?.air_freight?.code_smu}
                    </div>
                  </div>
                  <div className="row mt-0">
                    <div className="col-2 pdf-text">No. Manifest</div>
                    <div className="col-1 fs-8 text-center p-0">:</div>
                    <div className="col-7 text-uppercase pdf-head">
                      {data?.moda?.air_freight?.no_manifest}
                    </div>
                  </div>
                  <div className="row mt-0">
                    <div className="col-2 pdf-text">Total Berat</div>
                    <div className="col-1 fs-8 text-center p-0">:</div>
                    <div className="col-7 text-uppercase pdf-head">{`${shipmentItem?.total_weight} (KG) \n ${shipmentItem?.total_quantity} (Koli)`}</div>
                  </div>
                  <div className="row mt-0">
                    <div className="col-2 pdf-text">Flight Time</div>
                    <div className="col-1 fs-8 text-center p-0">:</div>
                    <div className="col-7 text-uppercase pdf-head">
                      {formatDate(data?.moda?.air_freight?.date)} -{' '}
                      {formatDate(data?.moda?.air_freight?.etd)}
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </>
      ) : null}
      <TableLastMile pageData={p} id={id} />
      <TableFirstConsole pageData={p} id={id} />
      <TableForwarder pageData={p} id={id} />
    </section>
  ));

  return (
    <div
      className={cn(
        'dropdown-item d-flex align-items-center cursor-pointer border-bottom'
      )}
      onClick={loading ? null : save}
    >
      {loading ? (
        <div className="spinner-border text-primary" role="status"></div>
      ) : (
        <>
          <Fi.FiDownload size={15} color="#202020" className="me-2" />
          Download Manifest
        </>
      )}
    </div>
  );
};

export default PDFManifest;
